import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PaymentSuccessModal = ({ 
  paymentSuccess, 
  onClose 
}) => {
  return (
    <Dialog open={paymentSuccess !== null} onOpenChange={() => onClose()}>
      <DialogContent className="bg-zinc-900 border-zinc-800">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <CheckCircle size={24} className="text-green-400" /> Ödeme Başarılı!
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-center">
          <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-6">
            <p className="text-green-400 text-4xl font-bold mb-2">+{paymentSuccess?.credits}</p>
            <p className="text-zinc-400">kredi hesabınıza eklendi</p>
          </div>
          <div className="bg-zinc-800 rounded-lg p-4">
            <p className="text-zinc-400 text-sm">Yeni Bakiyeniz</p>
            <p className="text-2xl font-bold text-yellow-400">{paymentSuccess?.balance} kredi</p>
          </div>
          <Button onClick={onClose} className="w-full bg-blue-600 hover:bg-blue-700">
            Tamam
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
